import React from "react";
import configs from "../../commons/configs";

const ConfigContext = React.createContext(configs);

export default ConfigContext;
